import React from "react";
import "./HomeSections.css";
import RoadmapImg from  "../../assets/Image/NewImages/CarrierRoadMap.jpeg";

function CareerRoadmap() {
    const handleCall = () => {
      window.location.href = "tel:+919886003080";
    };
  return (
    <section className="section-wrapper">
      <div className="container row valign-wrapper flex-wrap">
        <div className="col l6 s12 center">
          <img src={RoadmapImg} alt="" className="responsive-img custom-img" />
        </div>

        <div className="col l6 s12">
          <h4>Career Roadmap Planner</h4>
          <p>
            Compare and shortlist from thousands of colleges for your target and
            back-up careers.
          </p>
          <p>
            Learn about scholarships and entrance exams and get real time
            alerts.
          </p>
          <p>
            Plan a comprehensive roadmap to your dream career with guidance from
            our career coaches.
          </p>

          <button className="custom-btn" onClick={handleCall}>
            Schedule A Call Back
          </button>
        </div>
      </div>
    </section>
  );
}

export default CareerRoadmap;
